<template>
  <el-select @input='_value' :value='value'
    :placeholder='placeholder' :disabled='disabled'
    :style='selectStyle' @change='change'
    :size='size' filterable :clearable='clearable'>
    <el-option v-for='selectData in outSelectDatas'
      :key='selectData[selectKey ? selectKey : "code"]'
      :label='selectData[selectLabel ? selectLabel : "name"]'
      :value='selectData[selectValue ? selectValue : "code"]'
      :disabled='selectData["disabled"]'>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'Select',
  props: {
    selectKey: {
      default: '',
      type: String
    },

    selectLabel: {
      default: '',
      type: String
    },

    selectValue: {
      default: '',
      type: String
    },

    filter: {
      default: '',
      type: String
    },

    selectStyle: {
      default: '',
      type: String
    },

    placeholder: {
      default: '',
      type: String
    },

    value: {
      default: '',
      type: String
    },

    outSelectDatas: {
      default: null,
      type: Array
    },

    size: {
      default: '',
      type: String
    },

    clearable: {
      default: true,
      type: Boolean
    },

    disabled: {
      default: false,
      type: Boolean
    }
  },

  methods: {
    _value: function (newValue) {
      const that = this
      that.$emit('input', newValue)
    },

    change: function (val) {
      const that = this
      that.$emit('change', val)
    }
  }
}
</script>
